import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { FormDatePicker, FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";
import type { FieldProps } from "@/pages/ContactsPage/types";
import type { GeneralInfoTabFormValues } from "../../../schema";

export const AnniversaryField: FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<GeneralInfoTabFormValues>();
  const anniversaryDateLength = Number(watch(`anniversaries.${index}.anniversary`)?.length);
  const isOnlyYearPicker = anniversaryDateLength ? anniversaryDateLength !== 10 : false;
  return (
    <FieldLayout>
      <FormInput
        name={`anniversaries.${index}.description`}
        placeholder={t("contactsPage.generalInfo.type")}
      />
      <FormDatePicker
        showNow={false}
        hideOnlyYearCheckbox={false}
        isOnlyYearPicker={isOnlyYearPicker}
        name={`anniversaries.${index}.anniversary`}
        placeholder={t("common.date")}
      />
    </FieldLayout>
  );
};
